<script setup>
import {ref, inject, computed} from "vue";
import {getNoun} from "@/helpers/string";
import MatchMakingModal from "@/views/needs/need/matchMaking/MatchMakingModal.vue";

const need = inject('need');
const unreviewedStartups = inject('unreviewedStartups');
const getInfo = inject('getInfo');

const aiMatchMakingModal = ref(null);

const aiStartups = computed(() => unreviewedStartups.value.filter(startup => startup.source === 'ai'));
const ecoStartups = computed(() => unreviewedStartups.value.filter(startup => startup.source === 'ecosystem'));

function evaluate(type) {
    if (type === 'ai') {
        aiMatchMakingModal.value.open()
    }
}

defineExpose({
    evaluate,
});
</script>

<template>
    <div v-if="unreviewedStartups.length" class="card-needs mb-5">
        <header class="card-needs__header">
            <h3 class="heading3 heading3--match">Recommended Solutions</h3>
        </header>

        <div class="card-needs__content">
            <div class="row">
                <div v-if="aiStartups.length" class="col-12 col-md-6 mb-2">
                    <div class="card-headline">
                        <div class="card-headline__content">
                            <div class="card-needs__notification card-needs__notification--active card-needs__notification--ai" :title="need.recommended_startups_count">
                                <img :src="require('@/images/icon-gen-ai.svg')" alt="" />
                            </div>

                            <div class="text-center">
                                <div class="card-needs__plate">{{aiStartups.length}} new AI {{getNoun('recommendation')}}</div>
                            </div>
                        </div>

                        <footer class="card-headline__footer">
                            <a @click="evaluate('ai')" class="link-arrow justify-content-end">Review</a>
                        </footer>
                    </div>
                </div>

                <div v-if="ecoStartups.length" class="col-12 col-md-6 mb-2">
                    <div class="card-headline">
                        <div class="card-headline__content">
                            <div class="card-needs__notification card-needs__notification--active" title="6">
                                <img src="https://app2.dev.switchpitch.com/img/global.e72ae145.png" alt="" />
                            </div>

                            <div class="text-center">
                                <div class="card-needs__plate">NEA sent 6 solutions</div>
                            </div>
                        </div>
                        <footer class="card-headline__footer">
                            <a href="#" class="link-arrow justify-content-end">Review</a>
                        </footer>
                    </div>
                </div>
            </div>
        </div>

        <MatchMakingModal
            type="ai"
            ref="aiMatchMakingModal"
            @updated="getInfo"
        />
    </div>
</template>
